<template>
  <div>
    <p>redirecting to profile account modal</p>
  </div>
</template>

<script>
import AuthenticationMixin from '@/mixins/authentication';
import GlobalMixin from '@/mixins/global';

export default {
  mixins: [AuthenticationMixin, GlobalMixin],
  mounted() {
    this.$store.dispatch('ui/setProfileModalShown', 'accountModal');
    this.$router.push({ name: 'home' });
  },
};
</script>
